import styled from "styled-components";

export const PoisBountyContainer = styled.div<{
	stepCount: number;
	eventEnded: boolean;
	isClub: boolean;
}>`
	position: relative;
	border-radius: 2.29em;
	background-color: #0183a2;
	height: auto;
	overflow: hidden;

	&.page-variant {
		height: 42em;

		@media (min-width: 720px) {
			height: ${(props) => (props.isClub ? "42em" : "40.5em")};
		}
	}

	&.mega-menu-variant {
		@media (min-width: 720px) {
			font-size: clamp(6px, 0.7827vw, 10px);
		}
		@media (min-width: 1536px) {
			font-size: clamp(10px, 0.6527vw, 20px);
		}

		width: 56em;
		transform: translateX(10px);

		@media (max-width: 819px) {
			width: 0;
			display: none;
		}
	}

	&.portrait {
		height: ${(props) =>
			props.eventEnded ? "60em" : `calc((${props.stepCount} * 12em) + 43em)`};
	}
`;
